import React from "react";
import Classes from "./AppointmentTabs.module.css";

export default function ClientDetails({ booking }) {
  const u = booking?.userId || {};
  const name = u.name || [u.firstName, u.lastName].filter(Boolean).join(' ') || '—';
  const phone = u.phone || '—';
  const email = u.email || '—';
  const addr = [
    booking?.location?.address1, booking?.location?.city, booking?.location?.region, booking?.location?.postalCode
  ].filter(Boolean).join(", ") || '—';

  return (
    <section className={Classes.panel}>
      <h3 className={Classes.title}>Client Details</h3>
      <div className={Classes.row}><p className={Classes.label}>Name</p><p className={`${Classes.value} ${Classes.muted}`}>{name}</p></div>
      <div className={Classes.row}><p className={Classes.label}>Email</p><p className={`${Classes.value} ${Classes.muted}`}>{email}</p></div>
      <div className={Classes.row}><p className={Classes.label}>Phone</p><p className={`${Classes.value} ${Classes.muted}`}>{phone}</p></div>
      <div className={Classes.row}><p className={Classes.label}>Address</p><p className={`${Classes.value} ${Classes.muted}`}>{addr}</p></div>
      <div className={Classes.row}><p className={Classes.label}>Neighborhood</p><p className={`${Classes.value} ${Classes.muted}`}>{booking?.location?.neighborhood || '—'}</p></div>
      <div className={Classes.row}><p className={Classes.label}>Gate Code</p><p className={`${Classes.value} ${Classes.muted}`}>{booking?.location?.gateCode || '—'}</p></div>
      <div className={Classes.row}><p className={Classes.label}>Parking Spot #</p><p className={`${Classes.value} ${Classes.muted}`}>{booking?.location?.parkingSpotOrNotes || '—'}</p></div>
      <div className={Classes.row}><p className={Classes.label}>Company</p><p className={`${Classes.value} ${Classes.muted}`}>—</p></div>
      <div className={Classes.row}><p className={Classes.label}>Additional Notes</p><p className={`${Classes.value} ${Classes.muted}`}>{booking?.location?.additionalNotes || '—'}</p></div>
    </section>
  );
}
